@if (session) {
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer class="hdmui hdmui-background-2 sidenav" [attr.role]="'dialog'"
      [mode]="(isHandset$ | async) ? 'over' : 'over'" [opened]="false">
      <mat-toolbar>
        <h2>H+ Sample Backoffice</h2>
      </mat-toolbar>
      <content>
        <div dir="ltr" class=" image-background">
          <mat-icon svgIcon="app:deviceAdministrationApp" style="display: inline;"></mat-icon>
        </div>
        <div>
          <div style="padding: 12px">
            <span class="spacer"></span>
            <mat-divider></mat-divider>
            <mat-nav-list (click)="drawer.toggle()">
              <mat-list-item (click)="showAbout()">
                <mat-icon matListIcon svgIcon="hdmui:info"></mat-icon>
                <span matLine>{{'*.about' | translate }} </span>
              </mat-list-item>
            </mat-nav-list>
          </div>
        </div>
      </content>
    </mat-sidenav>
    <mat-sidenav-content class="hdmui-top-structure">
      <header HdmuiHeader>
        <app-toolbar class="hdmui-level00" [currentUser]="session" appIcon="app:deviceAdministrationApp"
          (sidebarOpen)="drawer.toggle()" [showSideBarIcon]="true" (logoutAction)="logout()">
          @if (!organization) {
            <app-title></app-title>
          }
          @if (organization) {
            <app-org-toolbar-title [value]="organization"></app-org-toolbar-title>
          }
        </app-toolbar>
        <app-nav class="hdmui-subnav" [ngClass]="{'hdmui-background-1' : (level | async) === 2}">
        </app-nav>
      </header>
      <section class="hdmui-content">
        <router-outlet></router-outlet>
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <div>
    <div class="container">
      <div class="row mt-5 mb-5">
        <div class="col-sm-12">
          <h1 class="mat-headline-4">{{'MSG_LOGINERROR_TXT' | translate}}</h1>
        </div>
        <div class="col-sm-12">
          <ol>
            <li>Please check your username and passwort and retry.</li>
            <li>If the problem is still occurs, please check your network connection.</li>
            <li>If the network connection is ok, please clear your browser cache and retry.</li>
          </ol>
        </div>
        <div class="col-sm-12 mt-3">
          <button mat-flat-button (click)="reload()" [matTooltip]="'RETRY' | translate ">
            <mat-icon svgIcon="hdmui:refresh"></mat-icon>
            {{'RETRY' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
}
